import { Toast } from "@shopify/polaris";
import React, { useEffect, useState } from "react";

const RateLimitToast = () => {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const show = (event) => setMessage(event.detail);
    window.addEventListener("store-rate-limit", show);

    return () => window.removeEventListener("store-rate-limit", show);
  }, []);

  return message ? <Toast content={message} error onDismiss={() => setMessage(null)} /> : null;
};

export default RateLimitToast;
